import { Injectable } from '@angular/core';
import { ApolloService } from './apollo.service';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubpoolService {

  constructor(private apolloService: ApolloService) { }

  getSubPools(filter:any): Observable<any> {
    const query = `
    query GetSubpoolsList($filter: SubpoolFilter) {
      getSubpoolsList(filter: $filter) {
        success
        statusCode
        message
        subpools {
          name
          subpoolCode
          sequenceNumber
        }
      }
    }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  

  createSubpool(input) {
    const query = `
        mutation CreateSubpool($input: SubpoolInput!) {
			createSubpool(input: $input) {
			  message
			  statusCode
			  subpool
			  success
			}
		}
       `;
    return this.apolloService.mutate(query,{ input: input })
  }

  updateSubpool(oldname: string, newname: string) {
    const query = `
        mutation UpdateSubpool($input: SubpoolInput!, $oldname: String) {
			updateSubpool(input: $input, oldname: $oldname) {
			  message
			  statusCode
			  subpool {
				name
			  }
			  success
			}
		}
       `;
    return this.apolloService.mutate(query, {
      "input": {
        "name": newname
      },
      "oldname": oldname
    })
  }

  deleteSubpool(name: string) {
    const query = `
        mutation DeleteSubpool($name: String) {
			deleteSubpool(name: $name) {
			  message
			  statusCode
			  subpool
			  success
			}
		  }
       `;
    return this.apolloService.mutate(query, {
      "name": name
    })
  }

  moveShipsOfSubpool(ships: string[], subPool: string) {
    const query = `
        mutation UpdateSubPoolOfVessels($input: VesselSubpoolInput!) {
			updateSubPoolOfVessels(input: $input) {
			  message
			  statusCode
			  success
			  vesselNumbers
			}
		  }
       `;
    return this.apolloService.mutate(query, {
      "input": {
        "ship": ships,
        "subPool": subPool
      }
    })
  }

  getSubpoolsMonthlyList(filter): Observable<any> {
    const query = `
      query GetSubpoolsMonthlyList($filter: SubpoolMonthFilter) {
        getSubpoolsMonthlyList(filter: $filter) {
          data {
            subpoolCode
            subpoolName
            year
            month
            fleet
            accountingVoyage
            scrubberSavings
          }
          message
          statusCode
          success
        }
      }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getSubpoolsYearsList(filter): Observable<any> {
    const query = `
    query GetSubpoolsYearsList($filter: SubpoolYearListFilter) {
      getSubpoolsYearsList(filter: $filter) {
        data {
          label
          value
        }
        message
        statusCode
        success
      }
    }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  createSubpoolsMonthlyData(input: any): Observable<any> {
    const query = `
      mutation CreateSubpoolScrubberVoyageMonthly($input: InputScrubberVoyage!) {
        createSubpoolScrubberVoyageMonthly(input: $input) {
          data {
            subpoolCode
            subpoolName
            fleet
            month
            year
            createdAt
            accountingVoyage
            scrubberSavings
          }
          message
          statusCode
          success
        }
      }
      `;
    return this.apolloService.mutate(query, { input: input })
  }
}
